module.exports = {
  data() {
    return {
      selectData: {  //下拉菜单数据
        education: ['不限', '中专', '高中', '大专', '本科', '硕士', '博士', 'MBA'], //学历
        school: ['不限', '985', '211', '海外前100'], //学校
        xperience: ['不限', '在读', '应届生', '1-3年', '3-5年', '5-10年', '10年以上'] //经验
      },

      hot_cities: [
        {
          "id": 0,
          "adcode": "0",
          "city_name": "全国"
        },
        {
          "id": 635,
          "adcode": "110000",
          "city_name": "北京"
        },
        {
          "id": 637,
          "adcode": "310000",
          "city_name": "上海"
        },
        {
          "id": 439,
          "adcode": "440100",
          "city_name": "广州"
        },
        {
          "id": 440,
          "adcode": "440300",
          "city_name": "深圳"
        },
        {
          "id": 511,
          "adcode": "510100",
          "city_name": "成都"
        },
        {
          "id": 197,
          "adcode": "330100",
          "city_name": "杭州"
        },
        {
          "id": 374,
          "adcode": "420100",
          "city_name": "武汉"
        },
        {
          "id": 336,
          "adcode": "410100",
          "city_name": "郑州"
        },
        {
          "id": 163,
          "adcode": "320100",
          "city_name": "南京"
        },
        {
          "id": 580,
          "adcode": "610100",
          "city_name": "西安"
        },
        {
          "id": 636,
          "adcode": "120000",
          "city_name": "天津"
        },
        {
          "id": 175,
          "adcode": "320500",
          "city_name": "苏州"
        },
        {
          "id": 410,
          "adcode": "430100",
          "city_name": "长沙"
        },
        {
          "id": 292,
          "adcode": "370100",
          "city_name": "济南"
        },
        {
          "id": 638,
          "adcode": "500000",
          "city_name": "重庆"
        }
      ],

      "cities": [
        {
          "group_name": "A",
          "part_cities": [
            {
              "id": 82,
              "adcode": "210300",
              "city_name": "鞍山"
            },
            {
              "id": 157,
              "adcode": "231281",
              "city_name": "安达"
            },
            {
              "id": 234,
              "adcode": "340800",
              "city_name": "安庆"
            },
            {
              "id": 340,
              "adcode": "410500",
              "city_name": "安阳"
            },
            {
              "id": 548,
              "adcode": "520400",
              "city_name": "安顺"
            },
            {
              "id": 589,
              "adcode": "610900",
              "city_name": "安康"
            },
            {
              "id": 640,
              "adcode": "820000",
              "city_name": "澳门"
            },
            {
              "id": 646,
              "adcode": "652901",
              "city_name": "阿克苏"
            },
            {
              "id": 658,
              "adcode": "654301",
              "city_name": "阿勒泰"
            }
          ]
        },
        
        {
          "group_name": "B",
          "part_cities": [
            {
              "id": 4,
              "adcode": "130600",
              "city_name": "保定"
            },
            {
              "id": 55,
              "adcode": "150200",
              "city_name": "包头"
            },
            {
              "id": 62,
              "adcode": "150800",
              "city_name": "巴彦淖尔"
            },
            {
              "id": 80,
              "adcode": "210500",
              "city_name": "本溪"
            },
            {
              "id": 106,
              "adcode": "220800",
              "city_name": "白城"
            },
            {
              "id": 111,
              "adcode": "220600",
              "city_name": "白山"
            },
            {
              "id": 229,
              "adcode": "340300",
              "city_name": "蚌埠"
            },
            {
              "id": 240,
              "adcode": "341600",
              "city_name": "亳州"
            },
            {
              "id": 307,
              "adcode": "371600",
              "city_name": "滨州"
            },
            {
              "id": 487,
              "adcode": "450500",
              "city_name": "北海"
            },
            {
              "id": 490,
              "adcode": "451000",
              "city_name": "百色"
            },
            {
              "id": 524,
              "adcode": "511900",
              "city_name": "巴中"
            },
            {
              "id": 549,
              "adcode": "520500",
              "city_name": "毕节"
            },
            {
              "id": 565,
              "adcode": "530500",
              "city_name": "保山"
            },
            {
              "id": 585,
              "adcode": "610300",
              "city_name": "宝鸡"
            },
            {
              "id": 596,
              "adcode": "620400",
              "city_name": "白银"
            },
            {
              "id": 635,
              "adcode": "110000",
              "city_name": "北京"
            }
          ]
        },
        
        {
          "group_name": "C",
          "part_cities": [
            {
              "id": 8,
              "adcode": "130800",
              "city_name": "承德"
            },
            {
              "id": 9,
              "adcode": "130900",
              "city_name": "沧州"
            },
            {
              "id": 36,
              "adcode": "140400",
              "city_name": "长治"
            },
            {
              "id": 57,
              "adcode": "150400",
              "city_name": "赤峰"
            },
            {
              "id": 104,
              "adcode": "220100",
              "city_name": "长春"
            },
            {
              "id": 173,
              "adcode": "320400",
              "city_name": "常州"
            },
            {
              "id": 176,
              "adcode": "320581",
              "city_name": "常熟"
            },
            {
              "id": 210,
              "adcode": "330282",
              "city_name": "慈溪"
            },
            {
              "id": 236,
              "adcode": "341100",
              "city_name": "滁州"
            },
            {
              "id": 241,
              "adcode": "341700",
              "city_name": "池州"
            },
            {
              "id": 410,
              "adcode": "430100",
              "city_name": "长沙"
            },
            {
              "id": 413,
              "adcode": "430700",
              "city_name": "常德"
            },
            {
              "id": 418,
              "adcode": "431000",
              "city_name": "郴州"
            },
            {
              "id": 445,
              "adcode": "445100",
              "city_name": "潮州"
            },
            {
              "id": 489,
              "adcode": "451400",
              "city_name": "崇左"
            },
            {
              "id": 511,
              "adcode": "510100",
              "city_name": "成都"
            },
            {
              "id": 571,
              "adcode": "532301",
              "city_name": "楚雄"
            },
            {
              "id": 616,
              "adcode": "540300",
              "city_name": "昌都"
            },
            {
              "id": 638,
              "adcode": "500000",
              "city_name": "重庆"
            },
            {
              "id": 651,
              "adcode": "652301",
              "city_name": "昌吉"
            }
          ]
        },
        
        {
          "group_name": "D",
          "part_cities": [
            {
              "id": 33,
              "adcode": "140200",
              "city_name": "大同"
            },
            {
              "id": 75,
              "adcode": "210200",
              "city_name": "大连"
            },
            {
              "id": 83,
              "adcode": "210600",
              "city_name": "丹东"
            },
            {
              "id": 98,
              "adcode": "210681",
              "city_name": "东港"
            },
            {
              "id": 135,
              "adcode": "230600",
              "city_name": "大庆"
            },
            {
              "id": 295,
              "adcode": "371400",
              "city_name": "德州"
            },
            {
              "id": 296,
              "adcode": "370500",
              "city_name": "东营"
            },
            {
              "id": 450,
              "adcode": "441900",
              "city_name": "东莞"
            },
            {
              "id": 505,
              "adcode": "460400",
              "city_name": "儋州"
            },
            {
              "id": 509,
              "adcode": "469007",
              "city_name": "东方"
            },
            {
              "id": 514,
              "adcode": "510600",
              "city_name": "德阳"
            },
            {
              "id": 525,
              "adcode": "511700",
              "city_name": "达州"
            },
            {
              "id": 570,
              "adcode": "532901",
              "city_name": "大理"
            },
            {
              "id": 603,
              "adcode": "621100",
              "city_name": "定西"
            }
          ]
        },
        
        {
          "group_name": "E",
          "part_cities": [
            {
              "id": 61,
              "adcode": "150600",
              "city_name": "鄂尔多斯"
            },
            {
              "id": 380,
              "adcode": "420700",
              "city_name": "鄂州"
            },
            {
              "id": 405,
              "adcode": "422801",
              "city_name": "恩施"
            }
          ]
        },
        
        {
          "group_name": "F",
          "part_cities": [
            {
              "id": 77,
              "adcode": "210900",
              "city_name": "阜新"
            },
            {
              "id": 79,
              "adcode": "210400",
              "city_name": "抚顺"
            },
            {
              "id": 237,
              "adcode": "341200",
              "city_name": "阜阳"
            },
            {
              "id": 250,
              "adcode": "350100",
              "city_name": "福州"
            },
            {
              "id": 253,
              "adcode": "350300",
              "city_name": "莆田"
            },
            {
              "id": 279,
              "adcode": "361000",
              "city_name": "抚州"
            },
            {
              "id": 454,
              "adcode": "440600",
              "city_name": "佛山"
            },
            {
              "id": 488,
              "adcode": "450600",
              "city_name": "防城港"
            }
          ]
        },
        
        {
          "group_name": "G",
          "part_cities": [
            {
              "id": 121,
              "adcode": "220381",
              "city_name": "公主岭"
            },
            {
              "id": 277,
              "adcode": "360700",
              "city_name": "赣州"
            },
            {
              "id": 439,
              "adcode": "440100",
              "city_name": "广州"
            },
            {
              "id": 481,
              "adcode": "450300",
              "city_name": "桂林"
            },
            {
              "id": 484,
              "adcode": "450800",
              "city_name": "贵港"
            },
            {
              "id": 512,
              "adcode": "510800",
              "city_name": "广元"
            },
            {
              "id": 516,
              "adcode": "511600",
              "city_name": "广安"
            },
            {
              "id": 545,
              "adcode": "520100",
              "city_name": "贵阳"
            },
            {
              "id": 623,
              "adcode": "640400",
              "city_name": "固原"
            }
          ]
        },
        
        {
          "group_name": "H",
          "part_cities": [
            {
              "id": 2,
              "adcode": "130400",
              "city_name": "邯郸"
            },
            {
              "id": 11,
              "adcode": "131100",
              "city_name": "衡水"
            },
            {
              "id": 54,
              "adcode": "150100",
              "city_name": "呼和浩特"
            },
            {
              "id": 58,
              "adcode": "150700",
              "city_name": "呼伦贝尔"
            },
            {
              "id": 87,
              "adcode": "211400",
              "city_name": "葫芦岛"
            },
            {
              "id": 96,
              "adcode": "210381",
              "city_name": "海城"
            },
            {
              "id": 132,
              "adcode": "230100",
              "city_name": "哈尔滨"
            },
            {
              "id": 134,
              "adcode": "231100",
              "city_name": "黑河"
            },
            {
              "id": 137,
              "adcode": "230400",
              "city_name": "鹤岗"
            },
            {
              "id": 167,
              "adcode": "320800",
              "city_name": "淮安"
            },
            {
              "id": 197,
              "adcode": "330100",
              "city_name": "杭州"
            },
            {
              "id": 199,
              "adcode": "330500",
              "city_name": "湖州"
            },
            {
              "id": 227,
              "adcode": "340100",
              "city_name": "合肥"
            },
            {
              "id": 230,
              "adcode": "340400",
              "city_name": "淮南"
            },
            {
              "id": 232,
              "adcode": "340600",
              "city_name": "淮北"
            },
            {
              "id": 235,
              "adcode": "341000",
              "city_name": "黄山"
            },
            {
              "id": 308,
              "adcode": "371700",
              "city_name": "菏泽"
            },
            {
              "id": 341,
              "adcode": "410600",
              "city_name": "鹤壁"
            },
            {
              "id": 379,
              "adcode": "421100",
              "city_name": "黄冈"
            },
            {
              "id": 381,
              "adcode": "420200",
              "city_name": "黄石"
            },
            {
              "id": 411,
              "adcode": "430400",
              "city_name": "衡阳"
            },
            {
              "id": 421,
              "adcode": "431200",
              "city_name": "怀化"
            },
            {
              "id": 443,
              "adcode": "441600",
              "city_name": "河源"
            },
            {
              "id": 449,
              "adcode": "441300",
              "city_name": "惠州"
            },
            {
              "id": 491,
              "adcode": "451200",
              "city_name": "河池"
            },
            {
              "id": 493,
              "adcode": "451100",
              "city_name": "贺州"
            },
            {
              "id": 502,
              "adcode": "460100",
              "city_name": "海口"
            },
            {
              "id": 586,
              "adcode": "610700",
              "city_name": "汉中"
            },
            {
              "id": 610,
              "adcode": "630200",
              "city_name": "海东"
            },
            {
              "id": 644,
              "adcode": "650500",
              "city_name": "哈密"
            }
          ]
        },
        
        {
          "group_name": "J",
          "part_cities": [
            {
              "id": 37,
              "adcode": "140500",
              "city_name": "晋城"
            },
            {
              "id": 40,
              "adcode": "140700",
              "city_name": "晋中"
            },
            {
              "id": 86,
              "adcode": "210700",
              "city_name": "锦州"
            },
            {
              "id": 105,
              "adcode": "220200",
              "city_name": "吉林"
            },
            {
              "id": 138,
              "adcode": "230800",
              "city_name": "佳木斯"
            },
            {
              "id": 141,
              "adcode": "230300",
              "city_name": "鸡西"
            },
            {
              "id": 180,
              "adcode": "320281",
              "city_name": "江阴"
            },
            {
              "id": 200,
              "adcode": "330400",
              "city_name": "嘉兴"
            },
            {
              "id": 204,
              "adcode": "330700",
              "city_name": "金华"
            },
            {
              "id": 265,
              "adcode": "350582",
              "city_name": "晋江"
            },
            {
              "id": 272,
              "adcode": "360400",
              "city_name": "九江"
            },
            {
              "id": 273,
              "adcode": "360200",
              "city_name": "景德镇"
            },
            {
              "id": 281,
              "adcode": "360800",
              "city_name": "吉安"
            },
            {
              "id": 292,
              "adcode": "370100",
              "city_name": "济南"
            },
            {
              "id": 304,
              "adcode": "370800",
              "city_name": "济宁"
            },
            {
              "id": 343,
              "adcode": "410800",
              "city_name": "焦作"
            },
            {
              "id": 373,
              "adcode": "419001",
              "city_name": "济源"
            },
            {
              "id": 377,
              "adcode": "420800",
              "city_name": "荆门"
            },
            {
              "id": 383,
              "adcode": "421000",
              "city_name": "荆州"
            },
            {
              "id": 447,
              "adcode": "445200",
              "city_name": "揭阳"
            },
            {
              "id": 453,
              "adcode": "440700",
              "city_name": "江门"
            },
            {
              "id": 541,
              "adcode": "510185",
              "city_name": "简阳"
            },
            {
              "id": 594,
              "adcode": "620200",
              "city_name": "嘉峪关"
            },
            {
              "id": 595,
              "adcode": "620300",
              "city_name": "金昌"
            },
            {
              "id": 598,
              "adcode": "620900",
              "city_name": "酒泉"
            }
          ]
        },
        
        {
          "group_name": "K",
          "part_cities": [
            {
              "id": 94,
              "adcode": "211282",
              "city_name": "开原"
            },
            {
              "id": 179,
              "adcode": "320583",
              "city_name": "昆山"
            },
            {
              "id": 337,
              "adcode": "410200",
              "city_name": "开封"
            },
            {
              "id": 558,
              "adcode": "530100",
              "city_name": "昆明"
            },
            {
              "id": 642,
              "adcode": "650200",
              "city_name": "克拉玛依"
            },
            {
              "id": 645,
              "adcode": "653101",
              "city_name": "喀什"
            }
          ]
        },
        
        {
          "group_name": "L",
          "part_cities": [
            {
              "id": 10,
              "adcode": "131000",
              "city_name": "廊坊"
            },
            {
              "id": 39,
              "adcode": "141100",
              "city_name": "吕梁"
            },
            {
              "id": 41,
              "adcode": "141000",
              "city_name": "临汾"
            },
            {
              "id": 81,
              "adcode": "211000",
              "city_name": "辽阳"
            },
            {
              "id": 109,
              "adcode": "220400",
              "city_name": "辽源"
            },
            {
              "id": 165,
              "adcode": "320700",
              "city_name": "连云港"
            },
            {
              "id": 207,
              "adcode": "331100",
              "city_name": "丽水"
            },
            {
              "id": 239,
              "adcode": "341500",
              "city_name": "六安"
            },
            {
              "id": 256,
              "adcode": "350800",
              "city_name": "龙岩"
            },
            {
              "id": 294,
              "adcode": "371500",
              "city_name": "聊城"
            },
            {
              "id": 302,
              "adcode": "371300",
              "city_name": "临沂"
            },
            {
              "id": 306,
              "adcode": "370116",
              "city_name": "莱芜"
            },
            {
              "id": 338,
              "adcode": "410300",
              "city_name": "洛阳"
            },
            {
              "id": 422,
              "adcode": "431300",
              "city_name": "娄底"
            },
            {
              "id": 482,
              "adcode": "450200",
              "city_name": "柳州"
            },
            {
              "id": 492,
              "adcode": "451300",
              "city_name": "来宾"
            },
            {
              "id": 519,
              "adcode": "511100",
              "city_name": "乐山"
            },
            {
              "id": 521,
              "adcode": "510500",
              "city_name": "泸州"
            },
            {
              "id": 546,
              "adcode": "520200",
              "city_name": "六盘水"
            },
            {
              "id": 561,
              "adcode": "530700",
              "city_name": "丽江"
            },
            {
              "id": 564,
              "adcode": "530900",
              "city_name": "临沧"
            },
            {
              "id": 593,
              "adcode": "620100",
              "city_name": "兰州"
            },
            {
              "id": 604,
              "adcode": "621200",
              "city_name": "陇南"
            },
            {
              "id": 607,
              "adcode": "622901",
              "city_name": "临夏"
            },
            {
              "id": 614,
              "adcode": "540100",
              "city_name": "拉萨"
            },
            {
              "id": 617,
              "adcode": "540400",
              "city_name": "林芝"
            }
          ]
        },
        
        {
          "group_name": "M",
          "part_cities": [
            {
              "id": 142,
              "adcode": "231000",
              "city_name": "牡丹江"
            },
            {
              "id": 231,
              "adcode": "340500",
              "city_name": "马鞍山"
            },
            {
              "id": 444,
              "adcode": "441400",
              "city_name": "梅州"
            },
            {
              "id": 458,
              "adcode": "440900",
              "city_name": "茂名"
            },
            {
              "id": 513,
              "adcode": "510700",
              "city_name": "绵阳"
            },
            {
              "id": 527,
              "adcode": "511400",
              "city_name": "眉山"
            }
          ]
        },
        
        {
          "group_name": "N",
          "part_cities": [
            {
              "id": 163,
              "adcode": "320100",
              "city_name": "南京"
            },
            {
              "id": 171,
              "adcode": "320600",
              "city_name": "南通"
            },
            {
              "id": 198,
              "adcode": "330200",
              "city_name": "宁波"
            },
            {
              "id": 251,
              "adcode": "350700",
              "city_name": "南平"
            },
            {
              "id": 257,
              "adcode": "350900",
              "city_name": "宁德"
            },
            {
              "id": 271,
              "adcode": "360100",
              "city_name": "南昌"
            },
            {
              "id": 348,
              "adcode": "411300",
              "city_name": "南阳"
            },
            {
              "id": 480,
              "adcode": "450100",
              "city_name": "南宁"
            },
            {
              "id": 515,
              "adcode": "511300",
              "city_name": "南充"
            },
            {
              "id": 518,
              "adcode": "511000",
              "city_name": "内江"
            }
          ]
        },
        
        {
          "group_name": "P",
          "part_cities": [
            {
              "id": 85,
              "adcode": "211100",
              "city_name": "盘锦"
            },
            {
              "id": 276,
              "adcode": "360300",
              "city_name": "萍乡"
            },
            {
              "id": 339,
              "adcode": "410400",
              "city_name": "平顶山"
            },
            {
              "id": 344,
              "adcode": "410900",
              "city_name": "濮阳"
            },
            {
              "id": 523,
              "adcode": "510400",
              "city_name": "攀枝花"
            },
            {
              "id": 563,
              "adcode": "530800",
              "city_name": "普洱"
            },
            {
              "id": 602,
              "adcode": "620800",
              "city_name": "平凉"
            }
          ]
        },
        
        {
          "group_name": "Q",
          "part_cities": [
            {
              "id": 5,
              "adcode": "130300",
              "city_name": "秦皇岛"
            },
            {
              "id": 133,
              "adcode": "230200",
              "city_name": "齐齐哈尔"
            },
            {
              "id": 140,
              "adcode": "230900",
              "city_name": "七台河"
            },
            {
              "id": 203,
              "adcode": "330800",
              "city_name": "衢州"
            },
            {
              "id": 254,
              "adcode": "350500",
              "city_name": "泉州"
            },
            {
              "id": 293,
              "adcode": "370200",
              "city_name": "青岛"
            },
            {
              "id": 409,
              "adcode": "429005",
              "city_name": "潜江"
            },
            {
              "id": 441,
              "adcode": "441800",
              "city_name": "清远"
            },
            {
              "id": 486,
              "adcode": "450700",
              "city_name": "钦州"
            },
            {
              "id": 507,
              "adcode": "469002",
              "city_name": "琼海"
            },
            {
              "id": 559,
              "adcode": "530300",
              "city_name": "曲靖"
            },
            {
              "id": 601,
              "adcode": "621000",
              "city_name": "庆阳"
            }
          ]
        },
        
        {
          "group_name": "R",
          "part_cities": [
            {
              "id": 301,
              "adcode": "371100",
              "city_name": "日照"
            },
            {
              "id": 615,
              "adcode": "540200",
              "city_name": "日喀则"
            }
          ]
        },
        
        {
          "group_name": "S",
          "part_cities": [
            {
              "id": 1,
              "adcode": "130100",
              "city_name": "石家庄"
            },
            {
              "id": 34,
              "adcode": "140600",
              "city_name": "朔州"
            },
            {
              "id": 74,
              "adcode": "210100",
              "city_name": "沈阳"
            },
            {
              "id": 107,
              "adcode": "220700",
              "city_name": "松原"
            },
            {
              "id": 108,
              "adcode": "220300",
              "city_name": "四平"
            },
            {
              "id": 139,
              "adcode": "230500",
              "city_name": "双鸭山"
            },
            {
              "id": 143,
              "adcode": "231200",
              "city_name": "绥化"
            },
            {
              "id": 144,
              "adcode": "230183",
              "city_name": "尚志"
            },
            {
              "id": 154,
              "adcode": "231081",
              "city_name": "绥芬河"
            },
            {
              "id": 166,
              "adcode": "321300",
              "city_name": "宿迁"
            },
            {
              "id": 175,
              "adcode": "320500",
              "city_name": "苏州"
            },
            {
              "id": 202,
              "adcode": "330600",
              "city_name": "绍兴"
            },
            {
              "id": 238,
              "adcode": "341300",
              "city_name": "宿州"
            },
            {
              "id": 252,
              "adcode": "350400",
              "city_name": "三明"
            },
            {
              "id": 278,
              "adcode": "361100",
              "city_name": "上饶"
            },
            {
              "id": 347,
              "adcode": "411200",
              "city_name": "三门峡"
            },
            {
              "id": 349,
              "adcode": "411400",
              "city_name": "商丘"
            },
            {
              "id": 375,
              "adcode": "420300",
              "city_name": "十堰"
            },
            {
              "id": 385,
              "adcode": "421300",
              "city_name": "随州"
            },
            {
              "id": 420,
              "adcode": "430500",
              "city_name": "邵阳"
            },
            {
              "id": 440,
              "adcode": "440300",
              "city_name": "深圳"
            },
            {
              "id": 442,
              "adcode": "440200",
              "city_name": "韶关"
            },
            {
              "id": 446,
              "adcode": "440500",
              "city_name": "汕头"
            },
            {
              "id": 448,
              "adcode": "441500",
              "city_name": "汕尾"
            },
            {
              "id": 503,
              "adcode": "460200",
              "city_name": "三亚"
            },
            {
              "id": 504,
              "adcode": "460300",
              "city_name": "三沙"
            },
            {
              "id": 517,
              "adcode": "510900",
              "city_name": "遂宁"
            },
            {
              "id": 588,
              "adcode": "611000",
              "city_name": "商洛"
            },
            {
              "id": 618,
              "adcode": "540500",
              "city_name": "山南"
            },
            {
              "id": 620,
              "adcode": "640200",
              "city_name": "石嘴山"
            },
            {
              "id": 637,
              "adcode": "310000",
              "city_name": "上海"
            },
            {
              "id": 660,
              "adcode": "659001",
              "city_name": "石河子"
            },
            {
              "id": 666,
              "adcode": "659007",
              "city_name": "双河"
            }
          ]
        },
        
        {
          "group_name": "T",
          "part_cities": [
            {
              "id": 3,
              "adcode": "130200",
              "city_name": "唐山"
            },
            {
              "id": 32,
              "adcode": "140100",
              "city_name": "太原"
            },
            {
              "id": 59,
              "adcode": "150500",
              "city_name": "通辽"
            },
            {
              "id": 78,
              "adcode": "211200",
              "city_name": "铁岭"
            },
            {
              "id": 110,
              "adcode": "220500",
              "city_name": "通化"
            },
            {
              "id": 170,
              "adcode": "321200",
              "city_name": "泰州"
            },
            {
              "id": 178,
              "adcode": "320585",
              "city_name": "太仓"
            },
            {
              "id": 205,
              "adcode": "331000",
              "city_name": "台州"
            },
            {
              "id": 233,
              "adcode": "340700",
              "city_name": "铜陵"
            },
            {
              "id": 305,
              "adcode": "370900",
              "city_name": "泰安"
            },
            {
              "id": 346,
              "adcode": "411100",
              "city_name": "漯河"
            },
            {
              "id": 408,
              "adcode": "429006",
              "city_name": "天门"
            },
            {
              "id": 468,
              "adcode": "440781",
              "city_name": "台山"
            },
            {
              "id": 550,
              "adcode": "520600",
              "city_name": "铜仁"
            },
            {
              "id": 582,
              "adcode": "610200",
              "city_name": "铜川"
            },
            {
              "id": 597,
              "adcode": "620500",
              "city_name": "天水"
            },
            {
              "id": 626,
              "adcode": "710100",
              "city_name": "台北"
            },
            {
              "id": 636,
              "adcode": "120000",
              "city_name": "天津"
            },
            {
              "id": 643,
              "adcode": "650400",
              "city_name": "吐鲁番"
            },
            {
              "id": 656,
              "adcode": "654201",
              "city_name": "塔城"
            },
            {
              "id": 665,
              "adcode": "659006",
              "city_name": "铁门关"
            }
          ]
        },
        
        {
          "group_name": "W",
          "part_cities": [
            {
              "id": 56,
              "adcode": "150300",
              "city_name": "乌海"
            },
            {
              "id": 60,
              "adcode": "150900",
              "city_name": "乌兰察布"
            },
            {
              "id": 174,
              "adcode": "320200",
              "city_name": "无锡"
            },
            {
              "id": 206,
              "adcode": "330300",
              "city_name": "温州"
            },
            {
              "id": 228,
              "adcode": "340200",
              "city_name": "芜湖"
            },
            {
              "id": 298,
              "adcode": "370700",
              "city_name": "潍坊"
            },
            {
              "id": 300,
              "adcode": "371000",
              "city_name": "威海"
            },
            {
              "id": 374,
              "adcode": "420100",
              "city_name": "武汉"
            },
            {
              "id": 396,
              "adcode": "421182",
              "city_name": "武穴"
            },
            {
              "id": 483,
              "adcode": "450400",
              "city_name": "梧州"
            },
            {
              "id": 506,
              "adcode": "469005",
              "city_name": "文昌"
            },
            {
              "id": 508,
              "adcode": "469006",
              "city_name": "万宁"
            },
            {
              "id": 510,
              "adcode": "469001",
              "city_name": "五指山"
            },
            {
              "id": 577,
              "adcode": "532601",
              "city_name": "文山"
            },
            {
              "id": 583,
              "adcode": "610500",
              "city_name": "渭南"
            },
            {
              "id": 600,
              "adcode": "620600",
              "city_name": "武威"
            },
            {
              "id": 621,
              "adcode": "640300",
              "city_name": "吴忠"
            },
            {
              "id": 641,
              "adcode": "650100",
              "city_name": "乌鲁木齐"
            },
            {
              "id": 663,
              "adcode": "659004",
              "city_name": "五家渠"
            }
          ]
        },
        
        {
          "group_name": "X",
          "part_cities": [
            {
              "id": 6,
              "adcode": "130500",
              "city_name": "邢台"
            },
            {
              "id": 38,
              "adcode": "140900",
              "city_name": "忻州"
            },
            {
              "id": 103,
              "adcode": "211481",
              "city_name": "兴城"
            },
            {
              "id": 164,
              "adcode": "320300",
              "city_name": "徐州"
            },
            {
              "id": 242,
              "adcode": "341800",
              "city_name": "宣城"
            },
            {
              "id": 249,
              "adcode": "350200",
              "city_name": "厦门"
            },
            {
              "id": 275,
              "adcode": "360500",
              "city_name": "新余"
            },
            {
              "id": 342,
              "adcode": "410700",
              "city_name": "新乡"
            },
            {
              "id": 345,
              "adcode": "411000",
              "city_name": "许昌"
            },
            {
              "id": 352,
              "adcode": "411500",
              "city_name": "信阳"
            },
            {
              "id": 376,
              "adcode": "420600",
              "city_name": "襄阳"
            },
            {
              "id": 378,
              "adcode": "420900",
              "city_name": "孝感"
            },
            {
              "id": 382,
              "adcode": "421200",
              "city_name": "咸宁"
            },
            {
              "id": 407,
              "adcode": "429004",
              "city_name": "仙桃"
            },
            {
              "id": 417,
              "adcode": "430300",
              "city_name": "湘潭"
            },
            {
              "id": 542,
              "adcode": "513401",
              "city_name": "西昌"
            },
            {
              "id": 578,
              "adcode": "533401",
              "city_name": "香格里拉"
            },
            {
              "id": 580,
              "adcode": "610100",
              "city_name": "西安"
            },
            {
              "id": 584,
              "adcode": "610400",
              "city_name": "咸阳"
            },
            {
              "id": 592,
              "adcode": "610481",
              "city_name": "兴平"
            },
            {
              "id": 609,
              "adcode": "630100",
              "city_name": "西宁"
            },
            {
              "id": 639,
              "adcode": "810000",
              "city_name": "香港"
            }
          ]
        },
        
        {
          "group_name": "Y",
          "part_cities": [
            {
              "id": 35,
              "adcode": "140300",
              "city_name": "阳泉"
            },
            {
              "id": 42,
              "adcode": "140800",
              "city_name": "运城"
            },
            {
              "id": 84,
              "adcode": "210800",
              "city_name": "营口"
            },
            {
              "id": 136,
              "adcode": "230700",
              "city_name": "伊春"
            },
            {
              "id": 168,
              "adcode": "320900",
              "city_name": "盐城"
            },
            {
              "id": 169,
              "adcode": "321000",
              "city_name": "扬州"
            },
            {
              "id": 219,
              "adcode": "330784",
              "city_name": "永康"
            },
            {
              "id": 220,
              "adcode": "330782",
              "city_name": "义乌"
            },
            {
              "id": 274,
              "adcode": "360600",
              "city_name": "鹰潭"
            },
            {
              "id": 280,
              "adcode": "360900",
              "city_name": "宜春"
            },
            {
              "id": 299,
              "adcode": "370600",
              "city_name": "烟台"
            },
            {
              "id": 384,
              "adcode": "420500",
              "city_name": "宜昌"
            },
            {
              "id": 389,
              "adcode": "420684",
              "city_name": "宜城"
            },
            {
              "id": 414,
              "adcode": "430900",
              "city_name": "益阳"
            },
            {
              "id": 415,
              "adcode": "430600",
              "city_name": "岳阳"
            },
            {
              "id": 419,
              "adcode": "431100",
              "city_name": "永州"
            },
            {
              "id": 456,
              "adcode": "445300",
              "city_name": "云浮"
            },
            {
              "id": 457,
              "adcode": "441700",
              "city_name": "阳江"
            },
            {
              "id": 485,
              "adcode": "450900",
              "city_name": "玉林"
            },
            {
              "id": 522,
              "adcode": "511500",
              "city_name": "宜宾"
            },
            {
              "id": 528,
              "adcode": "511800",
              "city_name": "雅安"
            },
            {
              "id": 560,
              "adcode": "530400",
              "city_name": "玉溪"
            },
            {
              "id": 581,
              "adcode": "610600",
              "city_name": "延安"
            },
            {
              "id": 587,
              "adcode": "610800",
              "city_name": "榆林"
            },
            {
              "id": 619,
              "adcode": "640100",
              "city_name": "银川"
            }
          ]
        },
        
        {
          "group_name": "Z",
          "part_cities": [
            {
              "id": 7,
              "adcode": "130700",
              "city_name": "张家口"
            },
            {
              "id": 15,
              "adcode": "130281",
              "city_name": "遵化"
            },
            {
              "id": 76,
              "adcode": "211300",
              "city_name": "朝阳"
            },
            {
              "id": 172,
              "adcode": "321100",
              "city_name": "镇江"
            },
            {
              "id": 177,
              "adcode": "320582",
              "city_name": "张家港"
            },
            {
              "id": 201,
              "adcode": "330900",
              "city_name": "舟山"
            },
            {
              "id": 215,
              "adcode": "330681",
              "city_name": "诸暨"
            },
            {
              "id": 255,
              "adcode": "350600",
              "city_name": "漳州"
            },
            {
              "id": 297,
              "adcode": "370300",
              "city_name": "淄博"
            },
            {
              "id": 303,
              "adcode": "370400",
              "city_name": "枣庄"
            },
            {
              "id": 336,
              "adcode": "410100",
              "city_name": "郑州"
            },
            {
              "id": 350,
              "adcode": "411600",
              "city_name": "周口"
            },
            {
              "id": 351,
              "adcode": "411700",
              "city_name": "驻马店"
            },
            {
              "id": 412,
              "adcode": "430800",
              "city_name": "张家界"
            },
            {
              "id": 416,
              "adcode": "430200",
              "city_name": "株洲"
            },
            {
              "id": 451,
              "adcode": "440400",
              "city_name": "珠海"
            },
            {
              "id": 452,
              "adcode": "442000",
              "city_name": "中山"
            },
            {
              "id": 455,
              "adcode": "441200",
              "city_name": "肇庆"
            },
            {
              "id": 459,
              "adcode": "440800",
              "city_name": "湛江"
            },
            {
              "id": 520,
              "adcode": "510300",
              "city_name": "自贡"
            },
            {
              "id": 526,
              "adcode": "512000",
              "city_name": "资阳"
            },
            {
              "id": 547,
              "adcode": "520300",
              "city_name": "遵义"
            },
            {
              "id": 562,
              "adcode": "530600",
              "city_name": "昭通"
            },
            {
              "id": 599,
              "adcode": "620700",
              "city_name": "张掖"
            },
            {
              "id": 622,
              "adcode": "640500",
              "city_name": "中卫"
            }
          ]
        }
      ],


    }
  },
}